import firebase from '../../../config/firebase';

const database = firebase.database();

// get Data from backend
export function getData(callback) {
  database.ref('api').on('value', function(snapshot) {
    const data = snapshot.val();
    callback(true, data, null);
  }, function(error) { console.log(error); });
}

// create new Data
export function createNewData (data, callback) {
  // create a new ID to identify the data
  var newId = database.ref().child('api').push().key;
  // add the id to the data that was passed to the function
  data["id"] = newId;
  // set data in backend
  database.ref('api/' + newId).set(data, function(error) {
    // determine which callback to send out
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  })
}

// edit an existing data set
export function editData (id, data, callback) {
  // set the existing data's id location to the edited data
  database.ref('api/' + id).set(data, function(error) {
    // callbacks
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  });
}

// remove existing data
export function deleteData(id, callback) {
  // remove at the location set by the id
  database.ref('api').child(id).remove(function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, id, null);
    }
  });
}
